<!--  -->
<template>
<div :class="['container',isMobile?'mcontainer':'']">
    <div :class="isMobile?'mnavs':'navs'" v-show="!(active==1)">
        <div class="item" @mouseover="hoverid=0" @mouseleave="hoverid=-1">
            <span v-show="hoverid==0">景区倾斜摄影列表</span>
            <img v-if="active==0" src="@/assets/images/icon1_active.png" alt="" @click="active=0">
            <img v-else src="@/assets/images/icon1.png" alt="" @click="toQX">
        </div>
        <div class="item" @mouseover="hoverid=1"  @mouseleave="hoverid=-1">
            <span v-show="hoverid==1">景点列表</span>
            <img v-if="active==1" src="@/assets/images/icon2_active.png" alt="" @click="active=-1">
            <img v-else src="@/assets/images/icon2.png" alt=""  @click="active=1">
        </div>
        <div class="item" @mouseover="hoverid=2"  @mouseleave="hoverid=-1">
            <span v-show="hoverid==2">精品典藏</span>
            <img v-if="active==2" src="@/assets/images/icon3_active.png" alt="" @click="active=-1">
            <img v-else src="@/assets/images/icon3.png" alt="" @click="active=2">
        </div>  
    </div>
     <scenes :class="['list',active==1?'active':'']" v-if="active==1">
        <span class="close" @click="active=-1"></span>
     </scenes>
     <antiques  :class="['list',active==2?'active':'']" v-if="active==2" v-show="!isDetail"  @showDetail="showDetail" @closeAntiques="closeAntiques"></antiques>
     <detail :class="['list',active==2?'active':'']" v-if="active==2&&isDetail" :activeItem="item" @closeDetail="closeDetail"></detail>
     <gis :class="['list',active==0?'active':'']" v-if="active==0" @closeGis="closeGis">
        <span class="close" @click="active=-1"></span>
     </gis>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from "@/utils/browser.js";
import scenes from '../scenes'
import antiques from '../antiques'
import detail from '../detail'
import gis from '../gislist'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    scenes:scenes,
    antiques:antiques,
    detail:detail,
    gis:gis
},
props:{
        active: Number
    },
data() {
    
//这里存放数据
return {
    isMobile: browser.mobile,
    isDetail:false,
    hoverid:-1,
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    toQX() {
        this.active = 0 ;
        // this.$router.push({
        //     path:'/pano',
        //     query:{
        //         qx:'qx'
        //     }
        // })
    },
    closeGis() {
        this.active= -1;
    },
    closeAntiques() {
        this.active = -1;
    },
    closeDetail() {
        this.isDetail = false;
    },
    showDetail(data) {
        this.isDetail = true;
        console.log(data)
        this.item = data
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .container {
        .navs {
            position:absolute;
            z-index:9;
            top:0;
            bottom:0;
            right:20px;
            margin:auto;
            display:flex;
            flex-direction: column;
            justify-content:center;
            pointer-events: none;
            .item {
                position:relative;
                width:2.1vw;
                margin:10px auto;
                cursor:pointer;
                pointer-events:auto;
                span {
                    position:absolute;
                    display:inline-block;
                    background:rgba(0,0,0,0.2);
                    color:#fff;
                    padding:5px; 
                    border-radius:5px;
                    font-size:12px;
                    width: 80px;
                    left: -85px;
                    text-align: center;
                }
            }
        }
        .mnavs {
            position:absolute;
            z-index:9;
            bottom:25vh;
            right:10px;
            margin:auto;
            display:flex;
            flex-direction: column;
            justify-content:center;
             pointer-events:none;
            .item {
                width:10.6vw;
                margin:10px auto;
                font-size:0;
                pointer-events:auto;
            }
        }
        .list {
            position:absolute;
            z-index:8;
            width:100%;
            height:100%;
            top:0;
            right:-100%;
            backdrop-filter: blur(10px);
            background:rgba(0,0,0,0.65);
            transition:all 1s ease;
            &.active {
                right:0;
            }
            .close {
                display:block;
                width:24px;
                height:24px;
                background:url(../../assets/images/cancel.png)center/100% no-repeat;
                position:absolute;
                right:5vw;
                top:2vw;
                box-shadow: 0px 0px 2px 2px #fff;
                border-radius: 50%;
                cursor:pointer;
            }
        }
    }
    .mcontainer {
        .list {
            z-index:99;
        }
    }
    
</style>